import RoutePath from 'shared/utils/namedUrls';

const basePath = '/';

export default {
  publicSearch: new RoutePath(basePath),
  publicSearchPreceptor: new RoutePath(`${basePath}p/:uuid`),
  preceptorProfile: new RoutePath(`${basePath}preceptor-profile/:uuid`),
};
